"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.id = void 0;
exports.id = 'gfa:locale-service';
//# sourceMappingURL=index.js.map